export const shareStates = [
    { id: 0, name: "Uploading" },
    { id: 1, name: "Processing" },
    { id: 2, name: "Active" },
    { id: 3, name: "Expired" },
    { id: 4, name: "Incomplete" },
    { id: 5, name: "Deleted" }
]
